import api from '../../../api/index';

export default {
  getAllCities({ commit }) {
    return api.get('/cities').then((response) => {
      commit('setCities', response.data.data);
    });
  },
  getAllSegments({ commit }) {
    return api.get('/segmentos').then((response) => {
      commit('setSegments', response.data.data);
    });
  },
  getAllCitiesByUfId({ commit }, ibgeUfId) {
    return api.get(`/uf/${ibgeUfId}/cities`).then((response) => {
      commit('setIbgeCities', response.data);
    });
  },
  verifyIfCityExistsByIbgeCode({ commit }, cityData) {
    return api.post('/exists/city', cityData);
  },
};
